<div style="font-size: 12px; width: 100%;" [formGroup]="tenantManagementFormGroup">
    <div class="panel-body">

      <!-- tenant management list -->
      <div class="panel-content-link">
        <mat-spinner *ngIf="loadingState" mode="indeterminate"
          class="circle" style="margin: 15px auto;"  diameter="20">
        </mat-spinner>
        <mat-grid-list cols="4" rowHeight="25px" *ngIf="!loadingState">
          <mat-grid-tile *ngFor="let link of managementLinks" colspan="1" rowspan="1">
            <img src="../images/new_ui/azurePortal.png" alt="{{link?.name}}">
            <a href="{{link?.link}}" target="_blank">{{link?.name}}</a>
          </mat-grid-tile>
        </mat-grid-list>
      </div>

      <!-- admin relationship table -->
      <div class="panel-content-link">
        <div class="row">
          <div class="col-sm">
            <div class="flex-item agreement-margin">
              <span class="highlight-text">Admin Relationships</span>
            </div>
          </div>
        </div>

        <mat-spinner  mode="indeterminate" *ngIf="isAdminRelationshipsLoading"
          class="circle" style="margin: 15px auto;" diameter="20">
        </mat-spinner>

        <div class="shared-outer-wrapper" *ngIf="!isAdminRelationshipsLoading && adminRelationships?.length">
          <table class="table mb-0">
            <thead>
              <tr>
                <th scope="col" style="width:40%;" class="align-left">NAME</th>
                <th scope="col" style="width:20%;" class="align-left">STATUS</th>
                <th scope="col" style="width:13%;" class="align-left">VALID FROM</th>
                <th scope="col" style="width:13%;" class="align-left">VALID TO</th>
                <th scope="col" style="width:7%;" class="align-right"></th>
                <th scope="col" style="width:7%;" class="align-right"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let ar of adminRelationships;index as i">
                  <tr>
                    <td class="align-left">
                      {{ ar?.displayName }}
                    </td>
                    <td class="align-left">
                      {{ ar.status === 'approvalPending' ? 'Pending Approval' : ar.status | titlecase }}
                    </td>
                    <td class="align-left">
                      {{ ar?.startDate | date: 'dd/MM/yyyy' }}
                    </td>
                    <td class="align-left">
                      {{ ar?.endDate | date: 'dd/MM/yyyy' }}
                    </td>
                    <td class="align-right">
                      <button
                        *ngIf="ar.status === 'approvalPending' && ar.acceptURL"
                        class="button button-red button-round"
                        style="margin-right: 5px;"
                        (click)="openLinkInNewTab(ar.acceptURL)"
                      >
                        Accept
                      </button>
                    </td>
                    <td class="align-right">
                      <button
                        *ngIf="ar.status === 'created'"
                        class="button button-red button-round"
                        (click)="terminateRelation(ar.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
              </ng-container>

            </tbody>
          </table>
        </div>

        <div *ngIf="!isAdminRelationshipsLoading && adminRelationships && !adminRelationships?.length">
          <span>Direct access to the management consoles requires a administrative relationship</span>
        </div>
      </div>

      <!-- new admin relationship -->
      <div class="panel-content-link">
        <div class="row">
          <div class="col-sm">
            <div class="flex-item agreement-margin">
              <span class="highlight-text link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/partner-center/gdap-introduction')">New Admin Relationship</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div>
              <span>
                Create an admin relationship as a
              </span>
              <mat-form-field appearance="fill" class="admin-relationship-title-select">
                <mat-select formControlName="title">
                  <ng-container *ngFor="let ar of Object.keys(ADMIN_RELATIONSHIPS)">
                    <mat-option value={{ADMIN_RELATIONSHIPS[ar].value}}>{{ ADMIN_RELATIONSHIPS[ar].displayName }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
              <span>
                for
              </span>
              <mat-form-field appearance="fill" class="day-select">
                <mat-select formControlName="days">
                  <ng-container>
                    <mat-option [value]="7">7</mat-option>
                    <mat-option [value]="14">14</mat-option>
                    <mat-option [value]="30">30</mat-option>
                    <mat-option *ngIf="tenantManagementFormGroup?.get('title')?.value === '1' || tenantManagementFormGroup?.get('title')?.value === '2'" [value]="60">60</mat-option>
                    <mat-option *ngIf="tenantManagementFormGroup?.get('title')?.value === '1' || tenantManagementFormGroup?.get('title')?.value === '2'"[value]="90">90</mat-option>
                    <mat-option *ngIf="tenantManagementFormGroup?.get('title')?.value === '1'" [value]="180">180</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
              <span>
                Days
              </span>
              <button class="button button-red button-round admin-relationship-create-button" (click)="createAdminRelationship()">
                Create
              </button>
            </div>

            <div style="margin: 10px 0px;">
              <div class="vertical-spacing">
                <ng-container [ngSwitch]="tenantManagementFormGroup?.get('title')?.value">
                  <ng-container *ngSwitchCase="'1'">
                    Support Analyst has access to read Azure Active Directory, raise and managed Microsoft Premium Support tickets on behalf of your tenancy.
                  </ng-container>
                  <ng-container *ngSwitchCase="'2'">
                    Support Operator has the same permissions as Support Analyst with the additional permissions to support basic user administration including license allocation.
                  </ng-container>
                  <ng-container *ngSwitchCase="'3'">
                    Support Admin has the same permissions as Support Operator with the additional permissions to support full user administration.
                  </ng-container>
                  <ng-container *ngSwitchCase="'4'">
                    Tenancy Technician has the same permissions as Support Admin as well the global reader permissions to read all tenancy data and administer billing data.
                  </ng-container>
                </ng-container>
              </div>

              <div class="vertical-spacing" style="margin-bottom: unset;">
                Attached Microsoft GDAP Roles:
              </div>
              <div>
                <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#directory-readers')">
                  Directory Readers
                </span>
              </div>
              <div>
                <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#service-support-administrator')">
                  Service Support Administrator
                </span>
              </div>
              <div>
                <span class="link-for-click" (click)="openLinkInNewTab(' https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#helpdesk-administrator')">
                  Helpdesk Administrator
                </span>
              </div>
              <div *ngIf="tenantManagementFormGroup?.get('title')?.value !== '1'">
                <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#license-administrator')">
                  License Administrator
                </span>
              </div>
              <div *ngIf="tenantManagementFormGroup?.get('title')?.value === '3' || tenantManagementFormGroup?.get('title')?.value === '4'">
                <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#user-administrator')">
                  User Administrator
                </span>
              </div>
              <ng-container *ngIf="tenantManagementFormGroup?.get('title')?.value == '4'">
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#global-reader')">
                    Global Reader
                  </span>
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#attribute-definition-reader')">
                    Attribute Definition Reader
                  </span>
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#attribute-assignment-reader')">
                    Attribute Assignment Reader
                  </span>
                </div>
                <!-- <div>
                  <span>
                    Attribute Definition Reader
                  </span>
                  <mat-icon matSuffix class="editmpnidicon ar-info-icon" placement="right" ngbTooltip="Read the definition of custom security attributes.">info</mat-icon>
                </div> -->
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#message-center-reader')">
                    Message Center Reader
                  </span>
                </div>
                <div>
                  <span  class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#message-center-privacy-reader')">
                    Message Center Privacy Reader
                  </span>
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#security-reader')">
                    Security Reader
                  </span>
                </div>
                <div class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#reports-reader')">
                  Reports Reader
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#billing-administrator')">
                    Billing Administrator
                  </span>
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#compliance-administrator')">
                    Compliance Administrator
                  </span>
                </div>
                <div>
                  <span class="link-for-click" (click)="openLinkInNewTab('https://docs.microsoft.com/en-us/azure/active-directory/roles/permissions-reference#insights-administrator')">
                    Insights Administrator
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>